const codes = {
  HELPTAP: 'HELPTAP',
  STARTUP: 'STARTUP'
};

export default codes;